module.exports = __webpack_public_path__ + "static/media/user.d1e8bdc0.svg";